import { forwardRef } from 'react';

import { IFRAME_ID } from '../SegmentHandler';
import { type Environment, getSegmentIframeUrl } from '../utils/environments';

export type AnalyticsIframeProps = {
	env: Environment;
};

export const AnalyticsIframe = forwardRef<HTMLIFrameElement, AnalyticsIframeProps>(({ env }, ref) => {
	const url = getSegmentIframeUrl(env);

	return (
		<iframe
			ref={ref}
			title="Chime Segment Analytics"
			id={IFRAME_ID}
			data-testid={IFRAME_ID}
			src={url}
			sandbox="allow-same-origin allow-scripts"
			style={{ width: 0, height: 0, border: 0, top: 0, visibility: 'hidden', position: 'absolute' }}
		/>
	);
});
